
import introducao from '@/assets/onboarding/introducao.png';
import { ApplicationState } from '@/store';
import React from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from "react-router-dom";
import './style.scss';

const OnboardingIntroduction: React.FC = () => {
    const { strings } = useSelector((state: ApplicationState) => {
        return {
            strings: state.locale.data,
        };
    });

    let history = useHistory();

    const buttonClickHandler = (): void => {
        history.push("/onboardingDescription");
    };
 
    return (
        <div className="onboardingIntroduction">
            <div className="radius">
                <span className="title">{strings.ONBOARDING.BOT_YOU_HERE}</span>

                <div className="introduction">
                    {strings.ONBOARDING.BOT_IM_CALLED}
                    <span className="name">{` ${strings.ONBOARDING.BOT_NAME}.`}</span>
                </div>

                <img src={introducao} className="imageFlo" />

                <span className="infoBot">{strings.ONBOARDING.BOT_WHO_I_AM}</span>
                <span className="infoClick">{strings.ONBOARDING.BOT_HOW_CAN_I_HELP_YOU}</span>

                <button type="button" className="button" onClick={buttonClickHandler}>
                    <span className="buttonText">{strings.ONBOARDING.BOT_LETS_GO.toUpperCase()}</span>
                </button>
            </div>
        </div>
    );
};

export default OnboardingIntroduction;
